import classNames from 'classnames';
import { c, t } from 'ttag';

import { Link } from '@ui/Link';
import { useRegion } from '@hook/useRegion';
import { Button } from '@ui/Button';
import TrashIcon from '@svg/trash.svg';

import s from './CartProduct.sss';

export type BasketProduct = {
  product?: {
    id: number
    name: string
    thumbnail: string
    url?: string | null
    price?: number | null
    oldPrice?: number | null
    brand?: {
      id: number | string
      name: string
    } | null
  } | null
  size?: {
    id: number | string
    name: string
  } | null
  count?: number
};

type CartProductProps = {
  onRequestRemove?: () => void
  basketProduct: BasketProduct
  onUpdateBasketProductCount?: (count: number) => void
  className?: string
};

export const CartProduct: React.FC<CartProductProps> = ({
  basketProduct,
  onRequestRemove,
  onUpdateBasketProductCount,
  className,
}) => {
  const { currencyName } = useRegion();
  const {
    product,
    size,
    count,
  } = basketProduct;

  if (!product) {
    throw new Error('No product');
  }

  // TODO(a.kravchuk): count < Product.count
  const canAddCount = !!count && count < 99;
  const canDecreaseCount = !!count && count > 1;

  const productImage = (
    <img
      className={s.productImage}
      src={product.thumbnail}
      alt={product.name}
    />
  );
  return (
    (
      <div className={classNames(s.root, className, { [s.withPadding]: !!onRequestRemove })}>
        <div className={classNames(s.productInfoGroup, { [s.withPadding]: !!onRequestRemove })}>
          {
          product.url
            ? (
              <Link
                theme="clean"
                href={product.url}
              >
                {productImage}
              </Link>
            )
            : productImage
        }
          <div className={s.productInfo}>
            <div className={s.brand}>{product.brand?.name}</div>
            {
            product.url
              ? (
                <Link
                  className={s.name}
                  theme="black"
                  href={product.url}
                >
                  {product.name}
                </Link>
              )
              : <div className={s.name}>{product.name}</div>
          }
            <div className={s.size}>{size?.name}</div>
          </div>
        </div>
        {/* 2 group */}
        {!!count && product.price && (
          <div className={s.basketProductAttributes}>
            <div className={s.attribute}>
              <div className={s.attributeName}>{t`Ціна`}</div>
              <div className={s.attributeValue}>
                {product.price || 0}
                {' '}
                {currencyName}
                {
                !!product.oldPrice
                  && (
                  <div className={s.oldPrice}>
                    {product.oldPrice}
                    {' '}
                    {currencyName}
                  </div>
                  )
              }
              </div>
            </div>

            <div className={s.attribute}>
              <div className={s.attributeName}>{t`Кількість`}</div>
              {
              onUpdateBasketProductCount
                ? (
                  <div className={classNames(s.attributeValue, s.productsCount)}>
                    <Button
                      theme="text"
                      className={s.countControll}
                      disabled={!canDecreaseCount}
                      onClick={() => onUpdateBasketProductCount(count - 1)}
                    >
                      -
                    </Button>
                    {count}
                    <Button
                      theme="text"
                      className={s.countControll}
                      disabled={!canAddCount}
                      onClick={() => onUpdateBasketProductCount(count + 1)}
                    >
                      +
                    </Button>
                  </div>
                )
                : (
                  <div className={s.attributeValue}>
                    {c('CartProduct').t`${count} шт.`}
                  </div>
                )
            }

            </div>

            <div className={s.attribute}>
              <div className={s.attributeName}>{t`Cума`}</div>
              <div className={s.attributeValue}>
                {(product?.price || 0) * count}
                {' '}
                {currencyName}
              </div>
            </div>
          </div>
        )}
        {
        !!onRequestRemove
        && (
        <TrashIcon
          className={s.trashIcon}
          onClick={onRequestRemove}
        />
        )
      }
      </div>
    )
  );
};
